import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import PropTypes from 'prop-types';
import { ContentControlledCarouselContext } from '../context/ContentControlledCarouselContext';

////////////////////////////////////////////
// TODO MISSING TESTS for activeSlide behaviour and resizing
////////////////////////////////////////////

const ContentControlledCarousel = ({ activeSlideName, children }) => {
  const swiperRef = useRef(null);

  const settings = {
    spaceBetween: 30,
    slidesPerView: 1,
    allowTouchMove: false,
    simulateTouch: false,
    initialSlide: 0,
    autoHeight: true,
  };

  // Swiper's autoHeight is conflicting with changing MUI Collapse element's height
  // this function, called by children, forces Swiper to recalculate height to handle that case
  const handleCollapseChange = () => {
    setTimeout(() => {
      swiperRef.current?.swiper?.updateAutoHeight();
    }, 300);
  };

  // handle the same case as function above
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (swiperRef.current?.swiper) {
        swiperRef.current.swiper.updateAutoHeight();
      }
    });

    const slides = swiperRef.current?.querySelectorAll('.swiper-slide') || [];
    slides.forEach((slide) => resizeObserver.observe(slide));

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    navigateToSlide(activeSlideName);
  }, [activeSlideName]);

  const navigateToSlide = (slideName) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiperInstance = swiperRef.current.swiper;

      const index = React.Children.toArray(children).findIndex(
        (child) => child.props.slideName === slideName
      );

      if (index !== -1) {
        swiperInstance.slideTo(index);
      }
    }
  };

  return (
    <ContentControlledCarouselContext.Provider value={{ handleCollapseChange }}>
      <div className="content-controlled-carousel-container">
        <Swiper {...settings} ref={swiperRef}>
          {React.Children.toArray(children)
            .filter(Boolean)
            .map((child, index) => (
              <SwiperSlide key={index}>{child}</SwiperSlide>
            ))}
        </Swiper>
      </div>
    </ContentControlledCarouselContext.Provider>
  );
};

ContentControlledCarousel.propTypes = {
  activeSlideName: PropTypes.string,
  children: PropTypes.node,
};

export default ContentControlledCarousel;
